import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgSrmTag = (props) => /* @__PURE__ */ _jsx("svg", {
	id: "Tag_-_SRM",
	"data-name": "Tag - SRM",
	xmlns: "http://www.w3.org/2000/svg",
	xmlnsXlink: "http://www.w3.org/1999/xlink",
	viewBox: "0 0 45.636 24.008",
	...props,
	children: /* @__PURE__ */ _jsxs("g", {
		id: "Group_1317",
		"data-name": "Group 1317",
		children: [
			/* @__PURE__ */ _jsx("path", {
				id: "Path_4275",
				"data-name": "Path 4275",
				d: "M25.493,36.362a3.877,3.877,0,0,1-2.582-.968l-1.223,1.876a6.353,6.353,0,0,0,3.785,1.311c1.98,0,3.747-1.15,3.747-3.025,0-3.388-4.562-2.884-4.562-4.154,0-.5.582-.786,1.281-.786a3.1,3.1,0,0,1,1.805.665l1.184-1.9a5.688,5.688,0,0,0-3.184-.988c-1.864,0-3.611,1.17-3.611,3.045,0,3.146,4.562,2.622,4.562,4.094,0,.484-.524.827-1.2.827",
				transform: "translate(-15.841 -20.443)",
				fill: "currentColor"
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Path_4276",
				"data-name": "Path 4276",
				d: "M55.462,28.6v9.781h2.524V32.227a2.783,2.783,0,0,1,2.29-1.412,3.387,3.387,0,0,1,.913.1l.291-2.44a4.986,4.986,0,0,0-.854-.081,3.464,3.464,0,0,0-2.737,1.19V28.6Z",
				transform: "translate(-40.51 -20.443)",
				fill: "currentColor"
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Path_4277",
				"data-name": "Path 4277",
				d: "M97.56,38.377V33.195a4.979,4.979,0,0,0-.951-3.226,4.229,4.229,0,0,0-3.3-1.573,4.6,4.6,0,0,0-3.339,1.533A4.046,4.046,0,0,0,86.805,28.4a3.662,3.662,0,0,0-2.543.988V28.6H81.836v9.781h2.523V32.025a2.883,2.883,0,0,1,2.194-1.21,1.854,1.854,0,0,1,1.417.6,2.358,2.358,0,0,1,.466,1.674v5.283H90.96V33.195a8.862,8.862,0,0,0-.078-1.089,2.919,2.919,0,0,1,2.271-1.291,1.854,1.854,0,0,1,1.417.6,2.358,2.358,0,0,1,.466,1.674v5.283Z",
				transform: "translate(-59.774 -20.443)",
				fill: "currentColor"
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Path_4278",
				"data-name": "Path 4278",
				d: "M41.44,18.394c0,4.789-3.586,8.685-7.993,8.685H10.187c-4.407,0-7.993-3.9-7.993-8.685S5.78,9.709,10.187,9.709h27.6V7.43h-27.6C4.571,7.43,0,12.348,0,18.394s4.57,10.964,10.186,10.964h23.26c5.616,0,10.186-4.918,10.186-10.964V13.57H41.44Z",
				transform: "translate(-0.001 -5.349)",
				fill: "currentColor"
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Path_4279",
				"data-name": "Path 4279",
				d: "M152.48,1.611,150.929,0,149.38,1.609,147.832,0l-1.551,1.611,1.549,1.609-1.549,1.608,1.551,1.611,1.548-1.608,1.549,1.608,1.551-1.611L150.932,3.22Z",
				transform: "translate(-106.844 0)",
				fill: "currentColor"
			})
		]
	})
});
export { SvgSrmTag as ReactComponent };
